import { getFullLanguageCode, getCurrentLanguageCode } from "utils/i18n";
import axios from "axios";
import constants, { UPDATE_TOKEN_TIMEFRAME } from "config/constants";
import keycloak from "keycloak";

const headers: any = {
    "x-language": getFullLanguageCode(getCurrentLanguageCode()),
};

// sample configurations
const axiosInstance = axios.create({
    headers,
    baseURL: constants.BACKEND_URL,
    timeout: 30000,
    withCredentials: false,
});

axiosInstance.interceptors.request.use((config) => {
    config.headers["x-api-key"] = constants.API_KEY;
    config.headers["Content-Type"] = "application/json";
    config.headers["x-language"] = getFullLanguageCode(
        getCurrentLanguageCode()
    );
    return config;
});

axiosInstance.interceptors.request.use(async (config) => {
    try {
        await keycloak.updateToken(UPDATE_TOKEN_TIMEFRAME);
    } catch (error) {
        console.error("Failed to refresh token", error);
        return Promise.reject(error);
    }

    const token = keycloak.token;

    if (token) {
        config.headers["Authorization"] = `Bearer ${token}`;
    }

    return config;
});

export default axiosInstance;
